"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = require("events");
__exportStar(require("./interfaces"), exports);
var IS_BROWSER;
var MAX_CANDIDATE_WAIT_ATTEMPTS = 3;
var StatsGatherer = /** @class */ (function (_super) {
    __extends(StatsGatherer, _super);
    function StatsGatherer(peerConnection, opts) {
        if (opts === void 0) { opts = {}; }
        var _this = _super.call(this) || this;
        _this.peerConnection = peerConnection;
        _this.haveConnectionMetrics = false;
        IS_BROWSER = typeof window !== 'undefined';
        _this.session = opts.session;
        _this.initiator = opts.initiator;
        _this.conference = opts.conference;
        _this.statsInterval = (opts.interval || 5) * 1000;
        _this.logger = opts.logger || console;
        if (['new', 'checking'].includes(peerConnection.iceConnectionState)) {
            if (peerConnection.iceConnectionState === 'checking') {
                _this.logger.warn("iceConnectionState is already in checking state so ice connect time may not be accurate");
                // tslint:disable-next-line:no-floating-promises
                _this.handleIceStateChange();
            }
            peerConnection.addEventListener('iceconnectionstatechange', _this.handleIceStateChange.bind(_this));
        }
        peerConnection.addEventListener('connectionstatechange', _this.handleConnectionStateChange.bind(_this));
        if (peerConnection.connectionState === 'connected') {
            _this.pollForStats();
        }
        return _this;
    }
    StatsGatherer.prototype.handleIceStateChange = function () {
        var _this = this;
        var state = this.peerConnection.iceConnectionState;
        if (state === 'checking') {
            if (IS_BROWSER) {
                this.iceStartTime = window.performance.now();
            }
        }
        if (state === 'connected') {
            if (this.haveConnectionMetrics) {
                return;
            }
            this.haveConnectionMetrics = true;
            var userAgent = void 0;
            var platform = void 0;
            var cores = void 0;
            if (IS_BROWSER) {
                this.iceConnectionTime = window.performance.now() - this.iceStartTime;
                userAgent = window.navigator.userAgent;
                platform = window.navigator.platform;
                cores = window.navigator.hardwareConcurrency;
            }
            var event_1 = {
                name: 'connect',
                userAgent: userAgent,
                platform: platform,
                cores: cores,
                session: this.session,
                conference: this.conference,
                connectTime: this.iceConnectionTime
            };
            return this.waitForSelectedCandidatePair()
                .then(function (stats) {
                _this.gatherSelectedCandidateInfo(stats, event_1);
                _this.emit('stats', event_1);
            });
        }
        if (state === 'failed') {
            if (IS_BROWSER) {
                this.iceFailedTime = window.performance.now() - this.iceStartTime;
            }
            return this.gatherStats().then(function (reports) {
                var event = {
                    name: 'failure',
                    session: _this.session,
                    initiator: _this.initiator,
                    conference: _this.conference,
                    failTime: _this.iceFailedTime,
                    iceRW: 0,
                    numLocalHostCandidates: 0,
                    numLocalSrflxCandidates: 0,
                    numLocalRelayCandidates: 0,
                    numRemoteHostCandidates: 0,
                    numRemoteSrflxCandidates: 0,
                    numRemoteRelayCandidates: 0
                };
                var localCandidates = _this.peerConnection.localDescription.sdp.split('\r\n').filter(function (line) {
                    return line.indexOf('a=candidate:') > -1;
                });
                var remoteCandidates = _this.peerConnection.remoteDescription.sdp.split('\r\n').filter(function (line) {
                    return line.indexOf('a=candidate:') > -1;
                });
                ['Host', 'Srflx', 'Relay'].forEach(function (type) {
                    event['numLocal' + type + 'Candidates'] = localCandidates.filter(function (line) {
                        return line.split(' ')[7] === type.toLowerCase();
                    }).length;
                    event['numRemote' + type + 'Candidates'] = remoteCandidates.filter(function (line) {
                        return line.split(' ')[7] === type.toLowerCase();
                    }).length;
                });
                _this.emit('stats', event);
            });
        }
    };
    StatsGatherer.prototype.waitForSelectedCandidatePair = function (delay, attempt) {
        var _this = this;
        if (delay === void 0) { delay = 300; }
        if (attempt === void 0) { attempt = 1; }
        return this.gatherStats()
            .then(function (reports) {
            if (!_this.getSelectedCandidatePair(reports)) {
                if (attempt > MAX_CANDIDATE_WAIT_ATTEMPTS) {
                    return Promise.reject(new Error('Max wait attempts for connected candidate info reached'));
                }
                return new Promise(function (resolve, reject) {
                    setTimeout(function () { return _this.waitForSelectedCandidatePair(delay, attempt + 1).then(resolve, reject); }, delay);
                });
            }
            else {
                return reports;
            }
        });
    };
    StatsGatherer.prototype.getSelectedCandidatePair = function (reports) {
        var activeCandidatePair = null;
        reports.forEach(function (_a) {
            var value = _a.value;
            var report = value;
            var selected = report.type === 'candidate-pair' && report.nominated && report.state === 'succeeded';
            if (selected) {
                activeCandidatePair = report;
            }
        });
        return activeCandidatePair;
    };
    StatsGatherer.prototype.gatherSelectedCandidateInfo = function (reports, event) {
        var activeCandidatePair = this.getSelectedCandidatePair(reports);
        if (activeCandidatePair) {
            var localId_1 = activeCandidatePair.localCandidateId;
            var remoteId_1 = activeCandidatePair.remoteCandidateId;
            var localCandidate_1;
            var remoteCandidate_1;
            reports.forEach(function (_a) {
                var key = _a.key, value = _a.value;
                var report = value;
                if (localId_1 && report.type === 'local-candidate' && report.id === localId_1) {
                    localCandidate_1 = report;
                    event.localCandidateType = report.candidateType;
                }
                if (remoteId_1 && report.type === 'remote-candidate' && report.id === remoteId_1) {
                    remoteCandidate_1 = report;
                    event.remoteCandidateType = report.candidateType;
                }
            });
            if (localCandidate_1 && remoteCandidate_1) {
                event.candidatePair = localCandidate_1.candidateType + ';' + remoteCandidate_1.candidateType;
                event.candidatePairDetails = {
                    local: localCandidate_1,
                    remote: remoteCandidate_1,
                    pair: activeCandidatePair
                };
            }
            if (localCandidate_1) {
                event.transport = localCandidate_1.transport || localCandidate_1.protocol;
                if (localCandidate_1.priority) {
                    // Chrome-specific mapping;
                    // but only chrome has priority set on the candidate currently.
                    var turnTypes = {
                        2: 'udp',
                        1: 'tcp',
                        0: 'tls'
                    };
                    var priority = parseInt(localCandidate_1.priority, 10);
                    event.turnType = turnTypes[priority >> 24];
                    event.networkType = localCandidate_1.networkType;
                }
                event.usingIPv6 = localCandidate_1.ipAddress && localCandidate_1.ipAddress.indexOf('[') === 0;
            }
        }
    };
    StatsGatherer.prototype.handleConnectionStateChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            var state;
            var _this = this;
            return __generator(this, function (_a) {
                state = this.peerConnection.connectionState;
                if (state === 'connected') {
                    this.pollForStats();
                }
                else if (state === 'disconnected') {
                    if (this.peerConnection.signalingState !== 'stable') {
                        return [2 /*return*/];
                    }
                    return [2 /*return*/, this.gatherStats().then(function (reports) {
                            var event = _this.createStatsReport(reports);
                            event.type = 'disconnected';
                            _this.emit('stats', event);
                        })];
                }
                else if (state === 'closed') {
                    if (this.pollingInterval) {
                        if (IS_BROWSER) {
                            window.clearInterval(this.pollingInterval);
                        }
                        this.pollingInterval = null;
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    StatsGatherer.prototype.pollForStats = function () {
        var _this = this;
        if (this.pollingInterval) {
            return;
        }
        var statsPoll = function () {
            return _this.gatherStats().then(function (reports) {
                var event = _this.createStatsReport(reports, true);
                if (event.tracks.length > 0 || event.remoteTracks.length > 0) {
                    _this.emit('stats', event);
                }
            });
        };
        if (IS_BROWSER) {
            window.setTimeout(statsPoll, 0);
            this.pollingInterval = window.setInterval(statsPoll, this.statsInterval);
        }
    };
    StatsGatherer.prototype.polyFillStats = function (results) {
        if (!results) {
            return [];
        }
        if (Array.isArray(results)) {
            return results;
        }
        var betterResults = [];
        if (this.isNativeStatsReport(results)) {
            results.forEach(function (value, key) {
                betterResults.push({ key: key, value: value });
            });
        }
        else if (Object.keys(results).length > 0) {
            Object.keys(results).forEach(function (key) {
                betterResults.push({
                    key: key,
                    value: results[key]
                });
            });
        }
        else {
            this.logger.warn('Unknown stats results format, returning unmodified', results);
            return [];
        }
        return betterResults;
    };
    StatsGatherer.prototype.isNativeStatsReport = function (results) {
        return typeof window.RTCStatsReport !== 'undefined' && results instanceof window.RTCStatsReport;
    };
    StatsGatherer.prototype.gatherStats = function () {
        return __awaiter(this, void 0, void 0, function () {
            var stats, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.peerConnection.getStats(null).then(this.polyFillStats.bind(this))];
                    case 1:
                        stats = _a.sent();
                        return [2 /*return*/, stats];
                    case 2:
                        e_1 = _a.sent();
                        this.logger.error('Failed to gather stats. Are you using RTCPeerConnection as your connection? {expect peerconnection.getStats}', { peerConnection: this.peerConnection, err: e_1 });
                        return [2 /*return*/, Promise.reject(e_1)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    StatsGatherer.prototype.createStatsReport = function (results, updateLastResult) {
        var _this = this;
        if (updateLastResult === void 0) { updateLastResult = true; }
        var event = {
            name: 'getStats',
            session: this.session,
            initiator: this.initiator,
            conference: this.conference,
            tracks: [],
            remoteTracks: []
        };
        var sources = results.filter(function (r) { return ['inbound-rtp', 'outbound-rtp'].indexOf(r.value.type) > -1; });
        sources.forEach(function (source) {
            _this.processSource({
                source: source.value,
                event: event,
                results: results
            });
        });
        var candidatePair = results.find(function (r) { return r.value.type === 'candidate-pair' && r.value.state === 'succeeded' && r.value.nominated === true; });
        if (candidatePair) {
            this.processSelectedCandidatePair({ report: candidatePair.value, event: event, results: results });
        }
        if (updateLastResult) {
            this.lastResult = results;
        }
        return event;
    };
    // todo source should be RTCInboundRTPStreamStats | RTCOutboundRTPStreamStats but the lib.dom definitions are out of date or not accurate
    StatsGatherer.prototype.processSource = function (_a) {
        var source = _a.source, results = _a.results, event = _a.event;
        var now = new Date(source.timestamp);
        // todo lastResultSource should be RTCInboundRTPStreamStats | RTCOutboundRTPStreamStats
        var lastResultSource = this.lastResult && this.lastResult.find(function (r) { return r.key === source.id; });
        lastResultSource = lastResultSource && lastResultSource.value;
        var lastResultRemoteSource;
        if (lastResultSource) {
            lastResultRemoteSource = this.lastResult && this.lastResult.find(function (r) { return r.value.localId === lastResultSource.id; });
            lastResultRemoteSource = lastResultRemoteSource && lastResultRemoteSource.value;
        }
        // for outbound-rtp, the correspondingRemoteSource will be remote-inbound-rtp
        // for inbound-rtp, the correspondingRemoteSource will be remote-outbound-rtp
        var correspondingRemoteSource;
        var transport;
        var candidatePair;
        var track;
        var mediaSource;
        var codec;
        results.forEach(function (r) {
            if (r.value.localId === source.id) {
                correspondingRemoteSource = r.value;
            }
            else if (r.key === source.transportId) {
                transport = r.value;
            }
            else if (r.key === source.trackId) {
                track = r.value;
            }
            else if (r.key === source.mediaSourceId) {
                mediaSource = r.value;
            }
            else if (r.key === source.codecId) {
                codec = r.value;
            }
        });
        if (transport) {
            candidatePair = results.find(function (r) { return r.key === transport.selectedCandidatePairId; });
            candidatePair = candidatePair && candidatePair.value;
        }
        if (candidatePair) {
            event.candidatePairHadActiveSource = true;
        }
        var kind = source.kind || source.mediaType;
        var isOutbound = source.type === 'outbound-rtp';
        var trackInfo = {
            track: track && track.trackIdentifier,
            kind: kind,
            jitter: getDefinedValue('jitter', source, correspondingRemoteSource),
            roundTripTime: getDefinedValue('roundTripTime', source, correspondingRemoteSource),
            packetsLost: getDefinedValue('packetsLost', source, correspondingRemoteSource) || 0,
            packetLoss: 0,
            bytes: parseInt(isOutbound ? source.bytesSent : source.bytesReceived, 10) || 0
        };
        if (codec) {
            trackInfo.codec = codec.payloadType + " " + codec.mimeType + " " + codec.clockRate;
        }
        if (lastResultSource) {
            var previousBytesTotal = parseInt(isOutbound ? lastResultSource.bytesSent : lastResultSource.bytesReceived, 10) || 0;
            var deltaTime = now.getTime() - new Date(lastResultSource.timestamp).getTime();
            trackInfo.bitrate = Math.floor(8 * (trackInfo.bytes - previousBytesTotal) / deltaTime);
        }
        var lastPacketsLost = getDefinedValue('packetsLost', lastResultSource, lastResultRemoteSource);
        if (isOutbound) {
            trackInfo.packetsSent = source.packetsSent;
            trackInfo.packetLoss = trackInfo.packetsLost / (trackInfo.packetsSent || 1) * 100;
            if (lastResultSource) {
                trackInfo.intervalPacketsSent = trackInfo.packetsSent - (lastResultSource.packetsSent || 0);
                trackInfo.intervalPacketsLost = trackInfo.packetsLost - (lastPacketsLost || 0);
                trackInfo.intervalPacketLoss = trackInfo.intervalPacketsLost / (trackInfo.intervalPacketsSent || 1) * 100;
            }
            trackInfo.retransmittedBytesSent = source.retransmittedBytesSent;
            trackInfo.retransmittedPacketsSent = source.retransmittedPacketsSent;
        }
        else {
            trackInfo.packetsReceived = source.packetsReceived;
            trackInfo.packetLoss = trackInfo.packetsLost / (trackInfo.packetsReceived * 100 || 1);
            if (lastResultSource) {
                trackInfo.intervalPacketsReceived = trackInfo.packetsReceived - lastResultSource.packetsReceived;
                trackInfo.intervalPacketsLost = trackInfo.packetsLost - lastPacketsLost;
                trackInfo.intervalPacketLoss = trackInfo.intervalPacketsLost / (trackInfo.intervalPacketsReceived || 1) * 100;
            }
        }
        if (track && kind === 'audio') {
            if (track.remoteSource) {
                trackInfo.audioLevel = track.audioLevel;
                trackInfo.totalAudioEnergy = track.totalAudioEnergy;
            }
            else {
                trackInfo.echoReturnLoss = track.echoReturnLoss;
                trackInfo.echoReturnLossEnhancement = track.echoReturnLossEnhancement;
            }
        }
        if (kind === 'audio' && mediaSource && (!track || !track.remoteSource)) {
            trackInfo.audioLevel = mediaSource.audioLevel;
            trackInfo.totalAudioEnergy = mediaSource.totalAudioEnergy;
        }
        // remove undefined properties from trackInfo
        Object.keys(trackInfo).forEach(function (key) { return trackInfo[key] === undefined && delete trackInfo[key]; });
        if (isOutbound) {
            event.tracks.push(trackInfo);
        }
        else {
            event.remoteTracks.push(trackInfo);
        }
    };
    StatsGatherer.prototype.processSelectedCandidatePair = function (_a) {
        var _this = this;
        var report = _a.report, event = _a.event, results = _a.results;
        // this is the active candidate pair, check if it's the same id as last one
        var localId = report.localCandidateId;
        var remoteId = report.remoteCandidateId;
        event.localCandidateChanged = !!this.lastActiveLocalCandidate && localId !== this.lastActiveLocalCandidate.id;
        event.remoteCandidateChanged = !!this.lastActiveRemoteCandidate && remoteId !== this.lastActiveRemoteCandidate.id;
        if (!this.lastActiveLocalCandidate || event.localCandidateChanged || event.remoteCandidateChanged) {
            results.forEach(function (result) {
                _this.checkLastActiveCandidate({
                    localId: localId,
                    remoteId: remoteId,
                    key: result.key,
                    report: result.value
                });
            });
        }
        if (this.lastActiveLocalCandidate) {
            event.networkType = this.lastActiveLocalCandidate.networkType;
            if (this.lastActiveRemoteCandidate) {
                event.candidatePair = this.lastActiveLocalCandidate.candidateType + ';' + this.lastActiveRemoteCandidate.candidateType;
            }
        }
        event.bytesSent = report.bytesSent;
        event.bytesReceived = report.bytesReceived;
        event.requestsReceived = report.requestsReceived;
        event.requestsSent = report.requestsSent;
        event.responsesReceived = report.responsesReceived;
        event.responsesSent = report.responsesSent;
        event.consentRequestsSent = report.consentRequestsSent;
        event.totalRoundTripTime = report.totalRoundTripTime;
    };
    StatsGatherer.prototype.checkLastActiveCandidate = function (_a) {
        var localId = _a.localId, remoteId = _a.remoteId, key = _a.key, report = _a.report;
        if (localId && report.type === 'local-candidate' && report.id === localId) {
            this.lastActiveLocalCandidate = report;
        }
        if (remoteId && report.type === 'remote-candidate' && report.id === remoteId) {
            this.lastActiveRemoteCandidate = report;
        }
    };
    return StatsGatherer;
}(events_1.EventEmitter));
exports.default = StatsGatherer;
// returns the first value in the list of objects that is not undefined or null
function getDefinedValue(propertyName) {
    var objects = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        objects[_i - 1] = arguments[_i];
    }
    var item = objects.find(function (obj) { return obj && (obj[propertyName] || obj[propertyName] === 0); });
    return item && item[propertyName];
}
//# sourceMappingURL=index.js.map